import { Roadmap } from './useGetRoadmapsQuery'

export const MOCK_ROADMAPS: Roadmap[] = [
    {
        _id: 'mock-roadmap-dhb311',
        product: 'DHB311',
        indication: 'Type 2 diabetes',
        therapyArea: 'Cardiometabolic',
        createdAt: '2025-01-14T09:00:00.000Z',
        isActive: true,
        isMaiaAvailable: true,
        allowedUsersCount: 10,
    },
    {
        _id: 'mock-roadmap-galligamab',
        product: 'Galligamab',
        indication: 'Cancer',
        therapyArea: 'Oncology',
        createdAt: '2025-02-03T09:00:00.000Z',
        isActive: true,
        isMaiaAvailable: true,
        allowedUsersCount: 222,
    },
    {
        _id: 'mock-roadmap-otrevia',
        product: 'Otrevia',
        indication: 'Allergies',
        therapyArea: 'Immunology & Inflammation',
        createdAt: '2025-03-21T09:00:00.000Z',
        isActive: true,
        isMaiaAvailable: false,
        allowedUsersCount: 333,
    },
    {
        _id: 'mock-roadmap-product-y',
        product: 'Product Y',
        indication: 'Dermatological Disorders',
        therapyArea: 'Immunology & Inflammation',
        createdAt: '2025-04-08T09:00:00.000Z',
        isActive: false,
        isMaiaAvailable: false,
        allowedUsersCount: 111,
    },
    {
        _id: 'mock-roadmap-product-z',
        product: 'Product Z',
        indication: 'Irritable Bowel Syndrome',
        therapyArea: 'Gastroenterology',
        createdAt: '2025-05-19T09:00:00.000Z',
        isActive: true,
        isMaiaAvailable: true,
        allowedUsersCount: 555,
    },
]
